// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background-color: #0e0635;
  color: white;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
}
button:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #5767aa;
}

.button-container button {
  background-color: #5767aa;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
  pointer-events: none;
  cursor: default;
}
.button-container button:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #5767aa;
}

.container-about{
  border: solid 2px #121212;
  transition: transform 50ms;
  max-width: 600px;
  font-family: IBM Plex Mono;
  padding: 12px 18px;
  background: rgb(255, 254, 254);

}
.container-about-ll{
  border: solid 2px #121212;
  transition: transform 50ms;
  max-width: 900px;
  font-family: IBM Plex Mono;
  padding: 12px 18px;
  background: rgb(255, 254, 254);

}
.br-m{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

}
.input-stl{
  border-radius: 50px;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
  max-width: 300px;
  /* display: flex;
  border-radius: 50px;
  border-style: none;
  outline: none;
  margin-top: 8px;
  padding: 12px 24px;
  background-color: #EAEEED; */
  /* max-height: 400px;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px; */
}
.link-acc {
  color: #000000;
  text-decoration: none;
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
  border-style: none;
  outline: none;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  padding: 12px 24px;
}

.link-acc:hover {
text-decoration: underline;
}
.container-about-a{
border: solid 2px #121212;
transition: transform 50ms;
max-width: 600px;
font-family: IBM Plex Mono;
padding: 12px 18px;
background: rgb(255, 255, 255);

}
`, "",{"version":3,"sources":["webpack://./src/components/rest/RestoForm.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;;AAEhC;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;;AAEzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;8BAM4B;EAC5B;;;;;wBAKsB;AACxB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;AACA,0BAA0B;AAC1B;AACA;AACA,yBAAyB;AACzB,0BAA0B;AAC1B,gBAAgB;AAChB,0BAA0B;AAC1B,kBAAkB;AAClB,8BAA8B;;AAE9B","sourcesContent":["button {\r\n  background-color: #0e0635;\r\n  color: white;\r\n  font-family: IBM Plex Mono;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 12px 18px;\r\n  border-radius: 4px;\r\n  border: solid 2px #121212;\r\n  box-shadow: 4px 4px #121212;\r\n  transition: transform 50ms,\r\n  box-shadow 50ms;\r\n}\r\nbutton:hover{\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #5767aa;\r\n}\r\n\r\n.button-container button {\r\n  background-color: #5767aa;\r\n  font-family: IBM Plex Mono;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  padding: 12px 18px;\r\n  border-radius: 4px;\r\n  border: solid 2px #121212;\r\n  box-shadow: 4px 4px #121212;\r\n  transition: transform 50ms,\r\n  box-shadow 50ms;\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n.button-container button:hover{\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #5767aa;\r\n}\r\n\r\n.container-about{\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  max-width: 600px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 12px 18px;\r\n  background: rgb(255, 254, 254);\r\n\r\n}\r\n.container-about-ll{\r\n  border: solid 2px #121212;\r\n  transition: transform 50ms;\r\n  max-width: 900px;\r\n  font-family: IBM Plex Mono;\r\n  padding: 12px 18px;\r\n  background: rgb(255, 254, 254);\r\n\r\n}\r\n.br-m{\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n\r\n}\r\n.input-stl{\r\n  border-radius: 50px;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n  max-width: 300px;\r\n  /* display: flex;\r\n  border-radius: 50px;\r\n  border-style: none;\r\n  outline: none;\r\n  margin-top: 8px;\r\n  padding: 12px 24px;\r\n  background-color: #EAEEED; */\r\n  /* max-height: 400px;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n  padding-top: 30px;\r\n  padding-left: 20px;\r\n  padding-right: 20px; */\r\n}\r\n.link-acc {\r\n  color: #000000;\r\n  text-decoration: none;\r\n  transform: translate(2px, 2px);\r\n  box-shadow: 2px 2px #121212;\r\n  border-style: none;\r\n  outline: none;\r\n  display: flex;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin: 0 auto;\r\n  padding: 12px 24px;\r\n}\r\n\r\n.link-acc:hover {\r\ntext-decoration: underline;\r\n}\r\n.container-about-a{\r\nborder: solid 2px #121212;\r\ntransition: transform 50ms;\r\nmax-width: 600px;\r\nfont-family: IBM Plex Mono;\r\npadding: 12px 18px;\r\nbackground: rgb(255, 255, 255);\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
